import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=1e81b90c&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e81b90c')) {
      api.createRecord('1e81b90c', component.options)
    } else {
      api.reload('1e81b90c', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=1e81b90c&", function () {
      api.rerender('1e81b90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I1iWLw9P1ob4/JS/comp/FavElement.vue"
export default component.exports